import { render } from "./StudyFilter.vue?vue&type=template&id=236c4027&scoped=true"
import script from "./StudyFilter.vue?vue&type=script&lang=js"
export * from "./StudyFilter.vue?vue&type=script&lang=js"

import "./StudyFilter.vue?vue&type=style&index=0&id=236c4027&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236c4027"]])

export default __exports__